    <div class="relative bg-white rounded-2xl border border-dark-text/8 shadow-[0_4px_16px_rgba(0,0,0,0.03)] p-4 sm:p-5 md:p-6 overflow-hidden transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_40px_rgba(0,0,0,0.07)]">
      <!-- Soft brand accent in the top-right corner -->
      <div class="absolute -top-8 -right-8 w-24 h-24 rounded-full opacity-50 pointer-events-none"
        [ngClass]="{
          'bg-jungle-green/10': tone === 'jungle',
          'bg-trinidad/10': tone === 'trinidad',
          'bg-gold/20': tone === 'gold',
          'bg-dark-text/5': tone === 'neutral'
        }"></div>

      <div class="relative flex items-center gap-2 mb-3">
        <span class="w-8 h-8 rounded-full inline-flex items-center justify-center shrink-0"
          [ngClass]="{
            'bg-jungle-green/10': tone === 'jungle',
            'bg-trinidad/10': tone === 'trinidad',
            'bg-gold/20': tone === 'gold',
            'bg-dark-text/8': tone === 'neutral'
          }">
          <span aria-hidden="true" class="material-symbols-outlined text-base"
            [ngClass]="{
              'text-jungle-green': tone === 'jungle',
              'text-trinidad': tone === 'trinidad',
              'text-muted-text': tone === 'neutral'
            }"
            [style.color]="tone === 'gold' ? '#b3760e' : null"
            style="font-variation-settings: 'FILL' 1;">{{ icon }}</span>
        </span>
        <span class="text-trinidad font-label uppercase tracking-[0.12em] text-[0.6rem] font-bold leading-tight">{{ label }}</span>
      </div>
      <div class="relative font-headline font-bold tracking-tight leading-none text-2xl sm:text-3xl md:text-4xl break-words"
        [ngClass]="{
          'text-jungle-green': tone === 'jungle',
          'text-trinidad': tone === 'trinidad',
          'text-dark-text': tone === 'neutral' || tone === 'gold'
        }">{{ value }}</div>

      @if (sparkPath) {
        <svg class="relative mt-3 block" width="100%" height="22" viewBox="0 0 80 22" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient [attr.id]="'spark-grad-' + uid" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" [attr.stop-color]="strokeColor" stop-opacity="0.18"></stop>
              <stop offset="100%" [attr.stop-color]="strokeColor" stop-opacity="0"></stop>
            </linearGradient>
          </defs>
          <path [attr.d]="sparkAreaPath" [attr.fill]="'url(#spark-grad-' + uid + ')'"></path>
          <polyline [attr.points]="sparkPath" fill="none" [attr.stroke]="strokeColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></polyline>
        </svg>
      }

      @if (trend) {
        <div class="relative text-[0.7rem] text-muted-text font-body mt-2">{{ trend }}</div>
      }
    </div>
